import React, { useState } from "react";
import "./AddCustomerModal.css";
import { addCustomerAPI } from "../../../utils/APIs/customerApis";
import { toast } from "react-toastify";

const AddCustomerModal = ({ isOpen, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    username: "",
    mobileNumber: "",
    email: "",
    state: "",
    city: "",
  });

  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();


    // if (!formData?.username) {
    //   toast.error("Name is required")
    //   return;
    // }
    // if (!formData?.email) {
    //   toast.error("Email is required")
    //   return;
    // } if (!formData?.mobileNumber) {
    //   toast.error("Mobile number is required")
    //   return;
    // }
    setLoading(true);
    try {
      const response = await addCustomerAPI({
        ...formData,
        userType: "user",
      });
      if (response?.data?.success) {
        toast.success(response?.data?.message || "Customer Added Successfully!")
        onSuccess(); // refresh table
        onClose();   // close modal
      }
      else {
        toast.error(response?.data?.message || "Failed to add Customer!")
      }


    }
    catch (error) {
      console.error("Add customer failed", error);

      const backendMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Failed to add customer";

      toast.error(backendMessage);
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <div className="customer-modal-overlay">
      <div className="customer-modal-container">
        <h3>Add Customer</h3>

        <form onSubmit={handleSubmit}>
          <input
            className="customer-input"
            type="text"
            name="username"
            placeholder="Full Name"
            value={formData.username}
            onChange={handleChange}
          // required
          />

          <input
            className="customer-input"
            type="email"
            name="email"
            placeholder="Email ID"
            value={formData.email}
            onChange={handleChange}
          // required
          />

          <input
            className="customer-input"
            type="text"
            name="mobileNumber"
            placeholder="Mobile No."
            value={formData.mobileNumber}
            onChange={handleChange}
          // required
          />



          <input
            className="customer-input"
            type="text"
            name="state"
            placeholder="State"
            value={formData.state}
            onChange={handleChange}
          />

          <input
            className="customer-input"
            type="text"
            name="city"
            placeholder="City"
            value={formData.city}
            onChange={handleChange}
          />

          <div className="modal-actions">
            <button className="btn-secondary" type="button" onClick={onClose}>
              Cancel
            </button>

            <button className="btn-primary" type="submit" disabled={loading}>
              {loading ? "Saving..." : "Add Customer"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCustomerModal;